// extracted by mini-css-extract-plugin
module.exports = {"banner":"SimpleBanner_banner__3cTVe","d":"SimpleBanner_d__i_lES","ecidr":"SimpleBanner_ecidr__XIYQ6"};